module.exports = __webpack_public_path__ + "media/images/hero/Slide 2.2 copie-ffd86e232559d756547b7aada541ca87.jpg";